import _ from 'underscore';
import Promise from 'bluebird';

import { getHelpContent } from './whats-new-get-content';
import { whatsNewDefaultParams } from './constants';

const loadContent = (baseHelpUrl, locale, helpParams) => {
  const params = _.defaults({}, helpParams, { language: locale }, whatsNewDefaultParams);
  return getHelpContent(baseHelpUrl, params).then((result) => {
    /* istanbul ignore else */
    if (result && result.Content) {
      const helpContent = result.Content;
      /* istanbul ignore else */
      if (helpContent.Content && helpContent.ContentHash) {
        return {
          content: helpContent.Content,
          cacheId: helpContent.ContentHash,
        };
      }
    }

    return null;
  });
};

const getContent = (baseHelpUrl, locale, getCurrentStatePromise, helpParams) => Promise.all([
  getCurrentStatePromise,
  loadContent(baseHelpUrl, locale, helpParams),
]).spread((currentState, latest) => {
  const current = _.isArray(currentState) ? _.first(currentState) : null;
  /* istanbul ignore else */
  if (!current || (latest && current.cacheId !== latest.cacheId)) {
    return latest;
  }

  return null;
}).catch(() => null);

export const getNews = ({
  baseHelpUrl,
  locale,
  getCurrentStatePromise,
  helpParams,
}) => new Promise((resolve) => {
  const content = getContent(baseHelpUrl, locale, getCurrentStatePromise, helpParams);
  content.then((news) => {
    const whatsnewData = news && news.cacheId ? { type: 'news', cacheId: news.cacheId } : {};
    resolve(whatsnewData);
  });
});
